module.exports = __webpack_public_path__ + "img/no-car.6dba6931.png";